import { render, staticRenderFns } from "./EloadTopups.vue?vue&type=template&id=0c0566c2"
import script from "./EloadTopups.vue?vue&type=script&lang=js"
export * from "./EloadTopups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports